import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './landing.css';

import Layout from 'components/global/Layout/Layout';
import Auth from 'components/auth/Auth/Auth';

class LandingPage extends React.Component {
  render() {
    return (
      <Layout>
        <div className='LandingPage-root'>
          <Auth />
        </div>
      </Layout>
    );
  }
}

const connectedLandingPage = connect(
  (state, props) => ({
    auth: state.firebase.auth
  })
)(LandingPage);

const wrappedLandingPage = firebaseConnect()(connectedLandingPage);

export default wrappedLandingPage;



// WEBPACK FOOTER //
// ./src/routes/landing/landing.js